import { IOrderActivityLog, Operation } from "../../../interfaces";
import CreatedLogComponent from "./CreatedLogComponent";
import DeletedLogComponent from "./DeletedLogComponent";
import ChangeLogComponent from "./ChangeLogComponent";
import { t } from "i18next";
import UpdatedLogComponent from "./UpdatedLogComponent";
import React from "react";
import { listActiveLogByOrderId } from "../../../api";
import { Divider } from "@mantine/core";
import useSubscriber from "../../../hooks/useSubscriber";
// @ts-expect-error type exists
import { onCreateActivityLog } from "../../../graphql/subscriptions";

/**
 * This is method which returns the component by operation action
 * @param param0 activity log details
 */
const HandleLogType = ({ activityLog }: { activityLog: IOrderActivityLog }) => {
  switch (activityLog.operation) {
    case Operation.Created:
      return <CreatedLogComponent activityLog={activityLog} />;
    case Operation.Updated:
      return <UpdatedLogComponent activityLog={activityLog} />;
    case Operation.Deleted:
      return <DeletedLogComponent activityLog={activityLog} />;
    case Operation.Change:
      return <ChangeLogComponent activityLog={activityLog} />; // Sie müssen diese neue Komponente erstellen
    default:
      return null;
  }
};

/**
 * This is main component to show activity log on behalf of operation and field returns the component.
 * @param param0 orderId
 * @returns
 */
const ActivityLogs = ({ orderId }: { orderId: string }) => {
  const [activityLogs, setActivityLogs] = React.useState<IOrderActivityLog[]>(
    []
  );
  const { data: createdActivityLog } = useSubscriber(onCreateActivityLog);
  const loadLogs = async () => {
    try {
      const logs = await listActiveLogByOrderId(orderId);
      if (!logs) return;
      setActivityLogs(logs);
    } catch (error) {
      console.log(error);
    }
  };

  /**
   * This method is used to add new activity log by order id
   * @param activityLog - Created activity log details
   */
  const handleSubscribeCreateActivityLog = (activityLog: IOrderActivityLog) => {
    if (activityLog.orderItemActivityLogsId !== orderId) return;
    setActivityLogs([activityLog, ...activityLogs]);
  };

  // Live update of change log
  React.useEffect(() => {
    if (
      !createdActivityLog ||
      (createdActivityLog &&
        !(
          createdActivityLog as Record<"onCreateActivityLog", IOrderActivityLog>
        ).onCreateActivityLog)
    )
      return;
    handleSubscribeCreateActivityLog(
      (createdActivityLog as Record<"onCreateActivityLog", IOrderActivityLog>)
        .onCreateActivityLog
    );
  }, [createdActivityLog]);

  React.useEffect(() => {
    if (!orderId) return;
    loadLogs();
  }, [orderId]);

  return (
    <div>
      <p className="section-heading"> {t("changelog").toString()}</p>
      {activityLogs.length > 0 && <Divider />}
      <div
        className={`${
          activityLogs.length > 5 && "h-40-vh overflow-y-scroll"
        } px-8`}
      >
        {activityLogs.length > 0 ? (
          activityLogs.map((activityLog) => {
            return (
              <div key={activityLog.id}>
                <HandleLogType key={activityLog.id} activityLog={activityLog} />
              </div>
            );
          })
        ) : (
          <React.Fragment>{String(t("noChangeLogs"))}</React.Fragment>
        )}
      </div>
    </div>
  );
};

export default ActivityLogs;
